import React, { useContext, useState, useEffect } from "react";
import "./Dashboard.css";
import Buckets from "../Common_Component/Buckets/Buckets";
import Table_Heading from "../Common_Component/Table_Heading/Table_Heading";
import New_User_Table from "./New_User_Table/New_User_Table";
import { Button, Form, Table } from "react-bootstrap";
import Border_btn from "../Common_Component/Border_btn/Border_btn";
import { Context } from "../../utils/context";
import { findAll } from "../../utils/apis/dashboard/dashboard";
import Pei_Chart from "../Common_Component/Pei_Chart/Pei_Chart";
import Donut_Chart from "../Common_Component/Donut_Chart/Donut_Chart";
import Polar_Area_Chart from "../Common_Component/Polar_Area_Chart/Polar_Area_Chart";
import { Link } from "react-router-dom";
import Heading_Holder from "../Common_Component/Heading_Holder/Heading_Holder";
import { formatAmount } from "../../utils/common";

function Dashboard() {
  const { UnauthorizedLogOut } = useContext(Context);
  const [data, setData] = useState([]);
  const [searchDateFrom, setSearchDatefrom] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");
  const getDataAll = async () => {
    try {
      const response = await findAll(searchDateFrom, searchDateTo);
      await setData(response?.data);
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [searchDateFrom, searchDateTo]);

  const today = new Date().toISOString().split("T")[0];
  const isRange = searchDateFrom || searchDateTo;
  const rangeQuery = isRange
    ? `from=${searchDateFrom}&to=${searchDateTo}`
    : `date=${today}`;

  const weekStartDate = new Date();
  weekStartDate.setDate(weekStartDate.getDate() - 6);
  const weekStart = weekStartDate.toISOString().split("T")[0];
  const weekQuery = `from=${weekStart}&to=${today}`;

  const displayDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  const bucketData = [
    {
      BucketText: "Total Customers",
      divText: data?.data?.total_users || 0,
      api: "/agent-management/customer",
    },
    // {
    //   BucketText: "Total Active Users",
    //   divText: data?.data?.total_active_users || 0,
    //   api: "/agent-management/customer",
    // },
    {
      BucketText: "Total In-Active Users",
      divText: `₹ ${data?.data?.total_inactive_users || 0}`,
      api: "/agent-management/customer?status=0",
    },
    {
      BucketText: "Total Wallet Amount",
      divText: `${formatAmount(data?.data?.total_wallet_amount) || 0}`,

      api: "/wallet/history",
    },
    {
      BucketText: isRange ? "Deposits" : "Todays Deposits",
      divText: `${formatAmount(data?.data?.todays_deposite_money) || 0}`,
      api: `/wallet/history?wallet_type=3&${rangeQuery}`,
    },
    {
      BucketText: isRange ? "Withdraws" : "Todays Withdraws",
      divText: `${formatAmount(data?.data?.todays_withdraw_money) || 0}`,
      api: `/wallet/history?wallet_type=1&${rangeQuery}`,
    },
  ];

  const weekBucketData = [
    {
      BucketText: "Weekly Deposits",
      divText: `${formatAmount(data?.data?.weekly_deposite_money) || 0}`,
      api: `/wallet/history?wallet_type=3&${weekQuery}`,
    },
    {
      BucketText: "Weekly Withdraws",
      divText: `${formatAmount(data?.data?.weekly_withdraw_money) || 0}`,
      api: `/wallet/history?wallet_type=1&${weekQuery}`,
    },
    {
      BucketText: "Weekly Bet Amount",
      divText: `${formatAmount(data?.data?.weekly_bet_amount) || 0}`,
      api: `/wallet/history?wallet_type=4&${weekQuery}`,
    },
    {
      BucketText: "Weekly Win Amount",
      divText: `${formatAmount(data?.data?.weekly_win_amount) || 0}`,
      api: `/wallet/history?wallet_type=5&${weekQuery}`,
    },
  ];

  if (data?.data?.customers_wallet) {
    bucketData.unshift({
      BucketText: "Total Customers Wallet Balance",
      divText: data?.data?.customers_wallet || 0,
      api: "/dashboard",
    });
  }

  if (data?.data?.agents_wallet) {
    bucketData.unshift({
      BucketText: "Total Agents Wallet Balance",
      divText: data?.data?.agents_wallet || 0,
      api: "/dashboard",
    });
  }

  if (data?.data?.total_agency_balance) {
    bucketData.unshift({
      BucketText: "Total Justbooking Balance",
      divText: data?.data?.total_agency_balance || 0,
      api: "/dashboard",
    });
  }

  const renderBuckets = (buckets) =>
    buckets.map((bucket, index) => (
      <div
        key={index}
        className="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-4 mt-3">
        <Link to={bucket?.api}>
          <div className="buckets-holder">
            <Buckets BucketText={bucket.BucketText} divText={bucket.divText} />
          </div>
        </Link>
      </div>
    ));

  return (
    <section className="Dashboard">
      <Heading_Holder headingText={"Dashboard"} />
      <div className="search-bar-holder mt-3">
        <div className="row align-items-end">
          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <Form.Group className="form-field" controlId="dashboardDateFrom">
              <Form.Label className="formlbb">From</Form.Label>
              <Form.Control
                type="date"
                max={searchDateTo || "9999-12-31"}
                value={searchDateFrom}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value && !/^\d{4}-\d{2}-\d{2}$/.test(value)) return;
                  setSearchDatefrom(value);
                }}
              />
            </Form.Group>
          </div>
          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <Form.Group className="form-field" controlId="dashboardDateTo">
              <Form.Label className="formlbb">To</Form.Label>
              <Form.Control
                type="date"
                min={searchDateFrom}
                max="9999-12-31"
                value={searchDateTo}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value && !/^\d{4}-\d{2}-\d{2}$/.test(value)) return;
                  setSearchDateTo(value);
                }}
              />
            </Form.Group>
          </div>
          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
            <Button
              type="button"
              className="reset-btn"
              onClick={() => {
                setSearchDatefrom("");
                setSearchDateTo("");
              }}>
              Reset
            </Button>
          </div>
        </div>
      </div>
      <div className="row mb-5">{renderBuckets(bucketData)}</div>

      <div className="week-data-holder mb-5">
        <Heading_Holder
          headingText={"Week Data"}
          subtext={`From ${displayDate(weekStart)} To ${displayDate(today)}`}
        />
        <div className="row">{renderBuckets(weekBucketData)}</div>
      </div>

     
    </section>
  );
}

export default Dashboard;
